import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { Tuple, SearchItem } from '../../entities';import { AppService } from '../../app.service';
import { catchError } from 'rxjs/operators';
import { CustomEvalLevelsVM, FilteredListVm, CustomeEvaluationRangeVM, ApplyToAllCompsVm, EquipmentForSelectionVM, ApplyToAllCompsEquipmentsVm, EquipmentRanges, WSreStatusModel, WSreFrameChainStatusModel , UpdateJobDetailsRequest } from './custom-eval.model';

@Injectable()
export class CustomEvalService {
  private userId = 1;

  constructor(private _http: HttpClient,
    private _app: AppService) {
  }

 

 public GetCustomEvaluationLevels()  :Observable<CustomEvalLevelsVM[]>{
    return this._http.get<CustomEvalLevelsVM[]>('api/ManageCustomEvaluation/GetEvaluationLevels').pipe(catchError(this.handleError));
  }


  public SetRangetoAllComponents(model: ApplyToAllCompsVm): Observable<Tuple> {
    //return this._http.post('api/ManageCustomEvaluation/ApplyCustomRangetoAllComponets', model).pipe(catchError(this.handleError));
    return this._http.post<Tuple>('api/ManageCustomEvaluation/ApplyCustomRangetoAllComponets', model)
    .pipe(
      catchError(this.handleError)
    );

  }

  public SetRangetoAllComponentsForSelectedEquipments(model: ApplyToAllCompsEquipmentsVm): Observable<Tuple> {
    //return this._http.post('api/ManageCustomEvaluation/ApplyCustomRangetoAllComponetsForEquipments', model).pipe(catchError(this.handleError));
    return this._http.post<Tuple>('api/ManageCustomEvaluation/ApplyCustomRangetoAllComponetsForEquipments', model)
    .pipe(
      catchError(this.handleError)
    );
  }


  public updateRangetoSelectedComponents(model: CustomeEvaluationRangeVM): Observable<Tuple> {
    //return this._http.post('api/ManageCustomEvaluation/UpdateEvaluationForComponents', model).pipe(catchError(this.handleError));
    return this._http.post<Tuple>('api/ManageCustomEvaluation/UpdateEvaluationForComponents', model)
    .pipe(
      catchError(this.handleError)
    );
  }

  public GetAllEquipmentforSelection(searchItemsParam: SearchItem[]): Observable<EquipmentForSelectionVM[]> {
    //return this._http.post('api/ManageCustomEvaluation/GetAllEquipmentforSelection', searchItemsParam).pipe(catchError(this.handleError));
    return this._http.post<EquipmentForSelectionVM[]>('api/ManageCustomEvaluation/GetAllEquipmentforSelection', searchItemsParam)
    .pipe(
      catchError(this.handleError)
    );
  }
  // public SetRangetoAllComponents_(LevelId:number,Value:number, A:number, B:number,C:number): Observable<Tuple> {
  //   const options = {
  //     params: new HttpParams().set('LevelId', LevelId.toString()).set('Value', Value.toString()).set('A', A.toString()).set('B', B.toString()).set('C', C.toString())
  //   };
  //   return this._http.get('api/ManageCustomEvaluation/ApplyCustomRangetoAllComponets', options).pipe(catchError(this.handleError));
  // }
  public DeleteSelectedLevelRanges(LevelId:number,Value:number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('LevelId', LevelId.toString()).set('Value', Value.toString())
    };
    return this._http.get<Tuple>('api/ManageCustomEvaluation/DeleteSelectedRange', options).pipe(catchError(this.handleError));
  }

  // public DeleteSelectedLevelRanges_Equipment(model: EquipmentRanges[]): Observable<Tuple> {
  //   return this._http.post('api/ManageCustomEvaluation/DeleteSelectedRange_Equipment', model).pipe(catchError(this.handleError));
  // }
  public DeleteSelectedLevelRanges_Equipment(model: EquipmentRanges[]): Observable<Tuple> {
    return this._http.post<Tuple>('api/ManageCustomEvaluation/DeleteSelectedRange_Equipment', model)
      .pipe(
        catchError(this.handleError)
      );
  }


  public GetSelectedLevelRanges(LevelId:number,Value:number): Observable<CustomeEvaluationRangeVM> {
    const options = {
      params: new HttpParams().set('LevelId', LevelId.toString()).set('Value', Value.toString())
    };
    return this._http.get<CustomeEvaluationRangeVM>('api/ManageCustomEvaluation/GetEvaluationRanges', options).pipe(catchError(this.handleError));
  }
  
  public GetSelectedLevelRangesForSelectedEquipment(equipmentId:number): Observable<CustomeEvaluationRangeVM> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<CustomeEvaluationRangeVM>('api/ManageCustomEvaluation/GetEvaluationRangesForSelectedEquipment', options).pipe(catchError(this.handleError));
  }

  public GetEquipmentsForUser(): Observable<FilteredListVm[]> {
    return this._http.get<FilteredListVm[]>('api/ManageCustomEvaluation/GetAllEquipmentsForUser').pipe(catchError(this.handleError));
  }
  public GetJobsitesForUser(): Observable<FilteredListVm[]> {
    return this._http.get<FilteredListVm[]>('api/ManageCustomEvaluation/GetAllJobsitesForUser').pipe(catchError(this.handleError));
  }

  public GetCustomersForUser(): Observable<FilteredListVm[]> {
    return this._http.get<FilteredListVm[]>('api/ManageCustomEvaluation/GetAllCustomersForUser').pipe(catchError(this.handleError));
  }

  public GetDelaersForUser(): Observable<FilteredListVm[]> {
    return this._http.get<FilteredListVm[]>('api/ManageCustomEvaluation/GetAllDealershipsForUser').pipe(catchError(this.handleError));
  }

  public getUserJobRoles(): Observable<string[]> {
    return this._http.get<string[]>('api/ManageCustomEvaluation/GetUserJobRoles').pipe(catchError(this.handleError));
  }

  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  public LoadWsreStatus(): Observable<WSreStatusModel[]> {
    return this._http.get<WSreStatusModel[]>('api/WSRE/WSREStatus').pipe(catchError(this.handleError));
  }
  // public updateRangetoSelectedComponents(model: CustomeEvaluationRangeVM): Observable<Tuple> {
  //   //return this._http.post('api/ManageCustomEvaluation/UpdateEvaluationForComponents', model).pipe(catchError(this.handleError));
  //   return this._http.post<Tuple>('api/ManageCustomEvaluation/UpdateEvaluationForComponents', model)
  //   .pipe(
  //     catchError(this.handleError)
  //   );
  // }
public UpdateJobDetails(model: UpdateJobDetailsRequest): Observable<any> {
debugger;
  return this._http.post<any>('api/WSRE/UpdateJobDetails', model)
  .pipe(
    catchError(this.handleError)
  );
}

  public GetWSRECurrentStatus(wsreId: number): Observable<WSreFrameChainStatusModel> {
    const options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<WSreFrameChainStatusModel>('api/WSRE/GetWSRECurrentStatus', options).pipe(catchError(this.handleError));
  }
  public ToggleWRSEFinalDisplay(wsreId: number,isEnableSpecs:boolean): Observable<WSreFrameChainStatusModel> {
    const options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('isEnableFinalSpecs', isEnableSpecs)
    };
    return this._http.get<WSreFrameChainStatusModel>('api/WSRE/ToggleWRSEFinalDisplay', options).pipe(catchError(this.handleError));
  }
  public GetWRSEFinalDisplayStatus(wsreId: number): Observable<WSreFrameChainStatusModel> {
    const options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<WSreFrameChainStatusModel>('api/WSRE/GetWRSEFinalDisplayStatus', options).pipe(catchError(this.handleError));
  }
}
